import * as Sentry from "@sentry/react";

// Centralizes Sentry initialization. Called once at app startup from
// src/index.js before <App/> renders.
//
// Disabled when REACT_APP_SENTRY_DSN is not set, which keeps local dev
// quiet and lets non-prod-like deploys skip Sentry without code changes.
//
// Sample rates: traces 0.2 (matches backend default), session replay only
// on errors. Tune via REACT_APP_SENTRY_TRACES_SAMPLE_RATE if needed.
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  const tracesSampleRate = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.2;
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "production";
  const release = process.env.REACT_APP_RELEASE || process.env.REACT_APP_GIT_SHA;

  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Drop noisy known-benign messages so they don't drown the signal.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
      "Non-Error promise rejection captured",
    ],
  });
}
